
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import Components from "./components";
import * as scrll from './funcs.js';
import './diagram.js';

import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import 'es6-shim';
import 'intersection-observer';

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

Vue.use(Vuelidate);

new Vue({
  el: "#app",
  delimiters: ["${", "}"],
});


//* objectfit polyfill =================================================== */

objectFitImages();
objectFitVideos();


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* breakpoints =================================================== */

function breakpointWidth(bp) {
  bpWidth = 768;
  if (bp == 'baby') {
    bpWidth = 479;
  }
  if (bp == 'teen') {
    bpWidth = 600;
  }
  if (bp == 'mama') {
    bpWidth = 768;
  }
  if (bp == 'mega') {
    bpWidth = 1279;
  }
  return bpWidth;
}

function breakpointMax(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() <= bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}

function breakpointMin(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() > bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}


//* scroll to anchor =================================================== */

window.history.scrollRestoration = 'manual';

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    scrll.scrollToAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    scrll.scrollToAnchor(hash);
  }
});

let didScroll;
$(window).scroll(function() {
  didScroll = true;
});
setInterval(function() {
  if (didScroll) {
    scrollspy();
    stickyHeader();
    didScroll = false;
  }
}, 250);

let lastScrollTop = 0;
const delta = 5;
const headerHeight = $('.SiteHeader').outerHeight();

function scrollspy() {
  const $as = $($('.PageContent-sideNav a[href^="#"]').get().reverse());
  $as.removeClass('s_active').each(function () {
    const id = $(this).attr('href').replace('#', '');
    if (id) {
      const target = $('#' + id);
      if (target.length && target[0].getBoundingClientRect().top <= 1) {
        $(this).addClass('s_active');
        return false;
      }
    }
  });
}

function stickyHeader() {
  const st = $(window).scrollTop();
  if (Math.abs(lastScrollTop - st) <= delta) return;
  if (st > lastScrollTop && st > headerHeight) {
    $('body').removeClass('is-header-down').addClass('is-header-up');
  } else {
    // if(st + $(window).height() < $(document).height()) {
      $('body').removeClass('is-header-up').addClass('is-header-down');
    // }
  }
  lastScrollTop = st;
}


$(document).ready(function() {

  // site menu

  const menu = document.querySelector('.SiteHeader-menu');
  menu.querySelector('.SiteHeader-menu-button').addEventListener('click', e => {
    menu.setAttribute('aria-expanded', String(menu.getAttribute('aria-expanded') !== 'true'));
  });

  document.querySelectorAll('.SiteNav-parent .SiteNav-link').forEach(el => {
    el.addEventListener('click', () => {
      el.parentNode.setAttribute('aria-expanded', 'true');
    });
  });

  document.querySelectorAll('.SiteNav-back').forEach(el => {
    el.addEventListener('click', () => {
      el.parentNode.parentNode.parentNode.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.activeElement) {
      const openEl = document.activeElement.closest('[aria-expanded=true]');
      if (openEl) {
        openEl.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // news

  var form = $('#newsFilterForm');
  var submit = function () {
    $('#newsResults').addClass('s_loading');

    form.find('select').each(function () {
      $(this).toggleClass('s_active', !!$(this).val());
    });

    var url = form.attr('action') + '?' + form.serialize();
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) {
        var doc = $(data);
        $('#newsResults').replaceWith(doc.find('#newsResults'));
      }
    });
  };

  form.on('submit', submit);
  form.find('select').on('change', submit);

  var timeout;
  form.find('input').on('input', function (e) {
    $('#newsResults').addClass('s_loading');
    clearTimeout(timeout);
    timeout = setTimeout(submit, 250);
  });

});


$(document).ready(function() {

  // partners

  function reload(url) {
    $('#partnersResults').addClass('s_loading');
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) {
        var doc = $(data);
        $('#partnersResults').replaceWith(doc.find('#partnersResults'));
      }
    });
  }

  var form = $('#partnersFilterForm');

  var submit = function () {
    form.find('select').each(function () {
      $(this).toggleClass('s_active', !!$(this).val());
    });

    var url = form.attr('action') + '?' + form.serialize();
    reload(url);
  };

  form.on('submit', submit);
  form.find('select').on('change', submit);

  var timeout;
  form.find('input').on('input', function (e) {
    $('#partnersResults').addClass('s_loading');
    clearTimeout(timeout);
    timeout = setTimeout(submit, 250);
  });

  $('.js-partnersReload').click(function(e) {
    e.preventDefault();
    reload(this.href);
  });

});

$(document).ready(function() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('s_animateIn');
        entry.target.style.animationPlayState = 'running';
      }
    });
  }, { rootMargin: '-200px 0px' });

  const targets = document.querySelectorAll('.js-animateOnScroll');
  targets.forEach(target => {
    target.classList.add('s_willAnimateIn');
    target.style.animationPlayState = 'paused';
    setTimeout(() => observer.observe(target), 100);
  });
});



// --- Formie ----
function formieSetupTouchedFields() {
  // Get fields
  const formieInputs = document.querySelectorAll('.fui-input');

  for (let i = 0; i < formieInputs.length; i++) {
    const input = formieInputs[i];
    
    input.addEventListener('focus', function () {
      input.closest('.fui-field').classList.add('fui-field-touched');
    });
  }
}

window.addEventListener("DOMContentLoaded", function () {
  formieSetupTouchedFields();
})